import { Slot, component$, type PropsOf } from "@builder.io/qwik";
import { Tooltip as HeadlessTooltip } from "@qwik-ui/headless";
import { cn } from "~/lib/cn";

export const Tooltip = component$<PropsOf<typeof HeadlessTooltip.Root>>(
  (props) => (
    <HeadlessTooltip.Root tabIndex={-1} {...props}>
      <Slot />
    </HeadlessTooltip.Root>
  ),
);

export const TooltipTrigger = component$<
  PropsOf<typeof HeadlessTooltip.Trigger>
>((props) => (
  <HeadlessTooltip.Trigger {...props} type="button">
    <Slot />
  </HeadlessTooltip.Trigger>
));

export const TooltipContent = component$<PropsOf<typeof HeadlessTooltip.Panel>>(
  ({ class: className, ...props }) => (
    <HeadlessTooltip.Panel
      {...props}
      class={cn(
        "bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[placement=bottom]:slide-in-from-top-2 data-[placement=left]:slide-in-from-right-2 data-[placement=right]:slide-in-from-left-2 data-[placement=top]:slide-in-from-bottom-2 z-50 overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md",
        className,
      )}
    >
      <Slot />
    </HeadlessTooltip.Panel>
  ),
);
